function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import TopHeaderNavigation from './navigations/TopHeaderNavigation';
export default function MobileTopHeader(_ref) {
  var appProps = _ref.appProps,
    navigation = _ref.navigation,
    navClass = _ref.navClass;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mobMenuButton = _useState2[0],
    setMobMenuButton = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    mobileMenu = _useState4[0],
    setMobileMenu = _useState4[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "navigation mobile-nav"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: appProps.frontendStyles.topHeader.color,
      paddingTop: 10,
      paddingBottom: 10
    },
    className: "top-nav-button ".concat(mobMenuButton ? 'close_icon' : 'menu_icon'),
    onClick: function onClick() {
      setMobMenuButton(function (prevState) {
        return !prevState;
      });
      setMobileMenu(function (prevState) {
        return !prevState;
      });
    }
  }), mobileMenu && /*#__PURE__*/React.createElement(TopHeaderNavigation, {
    appProps: appProps,
    navigation: navigation,
    navClass: "mobile animated fadeIn ".concat(navClass)
  })));
}